import { CompanyLogo } from '@/components/CompanyLogo';
import { useTranslation } from '@/i18n/useTranslation';
import styles from './PoweredByFooter.module.css';

interface Props {
  className?: string;
  showLabel?: boolean;
}

export default function PoweredByFooter({ className = '', showLabel = true }: Props) {
  const t = useTranslation();

  return (
    <footer className={`${styles.footer} ${className}`.trim()} aria-label={t.branding.companyName}>
      {showLabel ? <span className={styles.label}>{t.branding.poweredBy}</span> : null}
      <CompanyLogo height={42} />
    </footer>
  );
}
